import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Delete from "./pages/Delete";
import DeleteWithPhone from "./pages/DeleteWithPhone";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DriverPrivacyPolicy from "./pages/DriverPrivacyPolicy";
import NotFound from "./pages/NotFound";
import './App.css';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/:companyId/:accountId" element={<Delete />} />
        <Route path="/:companyId/:accountId/forgot" element={<DeleteWithPhone />} />
        <Route path="/:companyId/:accountId/account" element={ <Delete /> } />
        <Route path="/privacy-policy" element={ <PrivacyPolicy /> } exact static />
        <Route path="/driver-privacy-policy" element={ <DriverPrivacyPolicy /> } exact static />
        <Route path="/NotFound" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;